exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#modalHelp___BV_modal_outer_ {\n    z-index: 5000!important;\n}\n.modal-header h3 {\n     text-align: center!important;\n}\n\n", ""]);

// exports
